//
//  TrialFormSubMenu.tsx
//
//  Copyright:
//    NewtonGreen Technologies Pty. Ltd.
//    Level 4, 175 Scott Street
//    Newcastle, NSW, 2300
//    Australia
//
//    E-mail: support@newtongreen.com
//    Tel: (02) 4925 5288
//
//    All Rights Reserved.
//
//  Function of this module:
//    This module registers navigation for an individual trial form.
//

import { useContext, useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import TrialFormIdentityContext from "src/contexts/data/TrialFormIdentityContext";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import { createTrialFormSubMenu } from "src/routing/navigation";

/** Registers the innermost trial-form submenu when both identities are available. */
const TrialFormSubMenu: React.FC = () => {
    const { data: trialIdentity } = useContext(TrialIdentityContext);
    const { data: trialFormIdentity } = useContext(TrialFormIdentityContext);
    const subMenu = useMemo(
        () => createTrialFormSubMenu(trialIdentity, trialFormIdentity),
        [trialIdentity, trialFormIdentity]
    );

    return subMenu ? <AddPageSubMenu subMenu={subMenu} /> : null;
};

export default TrialFormSubMenu;
